import { useSelector } from 'react-redux';
import { IRootState } from 'Scripts/store';

export const useImpersonateUser = () => {
    return useSelector((state: IRootState) => state.impersonateUser);
};

export default useImpersonateUser;
